
import * as cloudimageRuntime$1DdZv1r5tN from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/cloudimage'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 576,
    "md": 768,
    "lg": 992,
    "xl": 1170,
    "xxl": 1440,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudimage",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 65
}

imageOptions.providers = {
  ['cloudimage']: { provider: cloudimageRuntime$1DdZv1r5tN, defaults: {"baseURL":"__collectionist__","cdnURL":"https://cdn.lecollectionist.com","format":["webp"]} }
}
        